import React from "react";
import { Facebook, Instagram, Twitter, Linkedin, ChevronUp } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_032ab9f9-3345-4ba2-8331-ffb088d80673/artifacts/nez840pj_logo1.png";

const footerLinks = {
  services: [
    { name: "Flight Bookings", href: "#services" },
    { name: "Hotel Reservations", href: "#services" },
    { name: "Visa Assistance", href: "#services" },
    { name: "Private Tours", href: "#services" },
  ],
  destinations: [
    { name: "Maldives", href: "#destinations" },
    { name: "Dubai", href: "#destinations" },
    { name: "Santorini", href: "#destinations" },
    { name: "Bali", href: "#destinations" },
  ],
  company: [
    { name: "About Us", href: "#about" },
    { name: "Our Team", href: "#about" },
    { name: "Careers", href: "#" },
    { name: "Contact", href: "#contact" },
  ],
};

const socialLinks = [
  { icon: Facebook, href: "#", label: "Facebook" },
  { icon: Instagram, href: "#", label: "Instagram" },
  { icon: Twitter, href: "#", label: "Twitter" },
  { icon: Linkedin, href: "#", label: "LinkedIn" },
];

export const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-foreground text-background">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 lg:col-span-1">
            <a href="#home" className="inline-block mb-6">
              <img
                src={LOGO_URL}
                alt="ELEV8 Travel"
                className="h-12 w-auto"
              />
            </a>
            <p className="text-background/70 text-sm mb-6 leading-relaxed">
              Elevating travel experiences since 2009. Your journey to
              extraordinary begins with us.
            </p>
            {/* Social Links */}
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  className="w-10 h-10 rounded-lg bg-background/10 flex items-center justify-center text-background/70 hover:bg-secondary hover:text-foreground transition-all duration-300"
                >
                  <social.icon className="w-5 h-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Services Links */}
          <div>
            <h4 className="font-semibold text-background mb-4">Services</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-background/70 text-sm hover:text-secondary transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Destinations Links */}
          <div>
            <h4 className="font-semibold text-background mb-4">Destinations</h4>
            <ul className="space-y-3">
              {footerLinks.destinations.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-background/70 text-sm hover:text-secondary transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-semibold text-background mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-background/70 text-sm hover:text-secondary transition-colors"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter */}
          <div className="col-span-2 md:col-span-4 lg:col-span-1">
            <h4 className="font-semibold text-background mb-4">Newsletter</h4>
            <p className="text-background/70 text-sm mb-4">
              Subscribe for exclusive offers and travel inspiration.
            </p>
            <form
              onSubmit={(e) => e.preventDefault()}
              className="flex gap-2"
            >
              <input
                type="email"
                placeholder="Your email"
                className="flex-1 px-4 py-2 rounded-lg bg-background/10 border border-background/20 text-sm text-background placeholder:text-background/50 focus:outline-none focus:border-secondary transition-colors"
              />
              <button
                type="submit"
                className="px-4 py-2 rounded-lg bg-secondary text-foreground text-sm font-medium hover:shadow-gold transition-all"
              >
                Join
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-background/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-background/60 text-sm text-center md:text-left">
              © {new Date().getFullYear()} ELEV8 Travel. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a
                href="#"
                className="text-background/60 text-sm hover:text-secondary transition-colors"
              >
                Privacy Policy
              </a>
              <a
                href="#"
                className="text-background/60 text-sm hover:text-secondary transition-colors"
              >
                Terms of Service
              </a>
              <button
                onClick={scrollToTop}
                className="p-2 rounded-lg bg-secondary/20 text-secondary hover:bg-secondary hover:text-foreground transition-all"
                aria-label="Scroll to top"
              >
                <ChevronUp className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
